module.exports = __webpack_public_path__ + "static/media/VAS_FEEDBACK_3_CLICKED.e6707098.svg";